// Generated by lighthouse-icons/config/bundle.js
import * as React from "react";

import { default as IconComponentAcademicCap} from './AcademicCap';
import { default as IconComponentBalancingBall} from './BalancingBall';
import { default as IconComponentBarChart} from './BarChart';
import { default as IconComponentBuildingWithPlant} from './BuildingWithPlant';
import { default as IconComponentCalendar} from './Calendar';
import { default as IconComponentCar} from './Car';
import { default as IconComponentChatBubble} from './ChatBubble';
import { default as IconComponentCircleAndSquare} from './CircleAndSquare';
import { default as IconComponentCircleWithChart} from './CircleWithChart';
import { default as IconComponentCirclesCutout} from './CirclesCutout';
import { default as IconComponentCirclesOverlapping} from './CirclesOverlapping';
import { default as IconComponentCompass} from './Compass';
import { default as IconComponentDocumentWithPen} from './DocumentWithPen';
import { default as IconComponentDocumentWithTarget} from './DocumentWithTarget';
import { default as IconComponentDocuments} from './Documents';
import { default as IconComponentEnVeiInn} from './EnVeiInn';
import { default as IconComponentEnvelopeOpen} from './EnvelopeOpen';
import { default as IconComponentFlag} from './Flag';
import { default as IconComponentGlobe} from './Globe';
import { default as IconComponentGrain} from './Grain';
import { default as IconComponentHeart} from './Heart';
import { default as IconComponentInnovasjonNorge} from './InnovasjonNorge';
import { default as IconComponentLock} from './Lock';
import { default as IconComponentMagnifyingGlass} from './MagnifyingGlass';
import { default as IconComponentMicrophone} from './Microphone';
import { default as IconComponentMicroscope} from './Microscope';
import { default as IconComponentMoneyCoins} from './MoneyCoins';
import { default as IconComponentMountains} from './Mountains';
import { default as IconComponentPeople} from './People';
import { default as IconComponentPerson} from './Person';
import { default as IconComponentPersonWithHouse} from './PersonWithHouse';
import { default as IconComponentPieChart} from './PieChart';
import { default as IconComponentQuote} from './Quote';
import { default as IconComponentRocket} from './Rocket';
import { default as IconComponentSailboat} from './Sailboat';
import { default as IconComponentShieldDiagonal} from './ShieldDiagonal';
import { default as IconComponentShieldVertical} from './ShieldVertical';
import { default as IconComponentShip} from './Ship';
import { default as IconComponentSquaresOverlapping} from './SquaresOverlapping';
import { default as IconComponentTarget} from './Target';
import { default as IconComponentTime} from './Time';
import { default as IconComponentTrophy} from './Trophy';


interface IconProps {
    name: string;
    className?: string;
    altText?: string;
}

const Icon: React.FC<IconProps> = (props) => {

    
    let ResolvedComponent;
    switch (props.name) {
        
            case 'AcademicCap':
            case 'academic-cap':
                ResolvedComponent = IconComponentAcademicCap;
                break;
            case 'BalancingBall':
            case 'balancing-ball':
                ResolvedComponent = IconComponentBalancingBall;
                break;
            case 'BarChart':
            case 'bar-chart':
                ResolvedComponent = IconComponentBarChart;
                break;
            case 'BuildingWithPlant':
            case 'building-with-plant':
                ResolvedComponent = IconComponentBuildingWithPlant;
                break;
            case 'Calendar':
            case 'calendar':
                ResolvedComponent = IconComponentCalendar;
                break;
            case 'Car':
            case 'car':
                ResolvedComponent = IconComponentCar;
                break;
            case 'ChatBubble':
            case 'chat-bubble':
                ResolvedComponent = IconComponentChatBubble;
                break;
            case 'CircleAndSquare':
            case 'circle-and-square':
                ResolvedComponent = IconComponentCircleAndSquare;
                break;
            case 'CircleWithChart':
            case 'circle-with-chart':
                ResolvedComponent = IconComponentCircleWithChart;
                break;
            case 'CirclesCutout':
            case 'circles-cutout':
                ResolvedComponent = IconComponentCirclesCutout;
                break;
            case 'CirclesOverlapping':
            case 'circles-overlapping':
                ResolvedComponent = IconComponentCirclesOverlapping;
                break;
            case 'Compass':
            case 'compass':
                ResolvedComponent = IconComponentCompass;
                break;
            case 'DocumentWithPen':
            case 'document-with-pen':
                ResolvedComponent = IconComponentDocumentWithPen;
                break;
            case 'DocumentWithTarget':
            case 'document-with-target':
                ResolvedComponent = IconComponentDocumentWithTarget;
                break;
            case 'Documents':
            case 'documents':
                ResolvedComponent = IconComponentDocuments;
                break;
            case 'EnVeiInn':
            case 'en-vei-inn':
                ResolvedComponent = IconComponentEnVeiInn;
                break;
            case 'EnvelopeOpen':
            case 'envelope-open':
                ResolvedComponent = IconComponentEnvelopeOpen;
                break;
            case 'Flag':
            case 'flag':
                ResolvedComponent = IconComponentFlag;
                break;
            case 'Globe':
            case 'globe':
                ResolvedComponent = IconComponentGlobe;
                break;
            case 'Grain':
            case 'grain':
                ResolvedComponent = IconComponentGrain;
                break;
            case 'Heart':
            case 'heart':
                ResolvedComponent = IconComponentHeart;
                break;
            case 'InnovasjonNorge':
            case 'innovasjon-norge':
                ResolvedComponent = IconComponentInnovasjonNorge;
                break;
            case 'Lock':
            case 'lock':
                ResolvedComponent = IconComponentLock;
                break;
            case 'MagnifyingGlass':
            case 'magnifying-glass':
                ResolvedComponent = IconComponentMagnifyingGlass;
                break;
            case 'Microphone':
            case 'microphone':
                ResolvedComponent = IconComponentMicrophone;
                break;
            case 'Microscope':
            case 'microscope':
                ResolvedComponent = IconComponentMicroscope;
                break;
            case 'MoneyCoins':
            case 'money-coins':
                ResolvedComponent = IconComponentMoneyCoins;
                break;
            case 'Mountains':
            case 'mountains':
                ResolvedComponent = IconComponentMountains;
                break;
            case 'People':
            case 'people':
                ResolvedComponent = IconComponentPeople;
                break;
            case 'Person':
            case 'person':
                ResolvedComponent = IconComponentPerson;
                break;
            case 'PersonWithHouse':
            case 'person-with-house':
                ResolvedComponent = IconComponentPersonWithHouse;
                break;
            case 'PieChart':
            case 'pie-chart':
                ResolvedComponent = IconComponentPieChart;
                break;
            case 'Quote':
            case 'quote':
                ResolvedComponent = IconComponentQuote;
                break;
            case 'Rocket':
            case 'rocket':
                ResolvedComponent = IconComponentRocket;
                break;
            case 'Sailboat':
            case 'sailboat':
                ResolvedComponent = IconComponentSailboat;
                break;
            case 'ShieldDiagonal':
            case 'shield-diagonal':
                ResolvedComponent = IconComponentShieldDiagonal;
                break;
            case 'ShieldVertical':
            case 'shield-vertical':
                ResolvedComponent = IconComponentShieldVertical;
                break;
            case 'Ship':
            case 'ship':
                ResolvedComponent = IconComponentShip;
                break;
            case 'SquaresOverlapping':
            case 'squares-overlapping':
                ResolvedComponent = IconComponentSquaresOverlapping;
                break;
            case 'Target':
            case 'target':
                ResolvedComponent = IconComponentTarget;
                break;
            case 'Time':
            case 'time':
                ResolvedComponent = IconComponentTime;
                break;
            case 'Trophy':
            case 'trophy':
                ResolvedComponent = IconComponentTrophy;
                break;        
    }
    
    
    return (
        <div className={props.className} aria-label={props.altText}>
            <ResolvedComponent />
        </div>
    );
}

export default Icon;
